/**
 * Status of this position.
 * tag: 706
 * @readonly
 * @enum {number} (int)
 */
export enum PosQtyStatus {
  /** Submitted */
  Submitted = 0,
  /** Accepted */
  Accepted = 1,
  /** Rejected */
  Rejected = 2,
}
